import request, { authOptions } from 'api/requestUtils'

type OrderStats = {
  total_purchase_count: number
}

/**
 * Leaf API helper for the member's purchase count.
 * Kept out of api/order so analytics eventDefinitions can read it without the
 * eventDefinitions ↔ api/order cycle (order.ts imports refundEvent).
 */
export async function getUserOrderCount(memberId: string | undefined, access_token?: string) {
  if (!memberId) {
    return {
      total_purchase_count: 0,
    }
  }

  const OrdersPath = '/api/orders/count'
  const response = await request.get<App.ApiResponse<Array<OrderStats>>>(
    OrdersPath,
    authOptions(access_token),
  )
  return {
    total_purchase_count: response.total_purchase_count,
  }
}
